import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
// import PropTypes from 'prop-types'
import { LoadingStyled } from "./styled";
import cx from "classnames";
import { Icons } from "components";

const Loading = ({
  theme_standard_loading,
  visible,
  timeout = 6000,
  message,
}) => {
  const customClass = cx({
    theme_standard_loading: theme_standard_loading,
  });

  let loadingRef = useRef();
  const [_isLoading, _setIsLoading] = useState(false);

  useEffect(() => {
    _setIsLoading(visible ? true : false);
    if (visible && timeout) {
      loadingRef.current = setTimeout(() => {
        _setIsLoading(false);
      }, timeout);
    } else {
      loadingRef.current && clearTimeout(loadingRef.current);
    }
    return () => {
      _setIsLoading(false);
      clearInterval(loadingRef.current);
    };
  }, [visible]); // eslint-disable-line react-hooks/exhaustive-deps

  if (typeof document === "undefined") return null;
  return ReactDOM.createPortal(
    <LoadingStyled visible={_isLoading}>
      <div className={customClass}>
        <Icons.Loading />
        {message && <div className="bg_loading_message">{message}</div>}
      </div>
    </LoadingStyled>,
    document.body
  );
};

Loading.propTypes = {};

export default Loading;
